var sw = sw || {};


// Aload
//-----------------------------------------------------------------
sw.aload = function() {

    aload();
    
};


$(document).ready(function (){
    sw.aload();
});